import theme from '@churni/theme';

export default theme;
